export enum MemberActivitiesTabEnum {
    notExported = 0,
    exported = 1
}
